import { Text, TextProps } from "@mantine/core";
import { CSSProperties, ReactNode } from "react";
import { currencyFormat, tugrug } from "../../utils";

interface RenderTextProps extends Omit<TextProps, "c" | "fw" | "ta" | "style"> {
  text: ReactNode | number | string | null | undefined;
  isAmount?: boolean;
  /** With isAmount: render `1,234,567₮` (app-wide list format) instead of `1'234'567.00 ₮`. */
  plainAmount?: boolean;
  color?: string;
  fontWeight?: number;
  style?: CSSProperties;
  component?: any;
  fallback?: string;
}

const isNullish = (v: unknown): v is null | undefined => v === null || v === undefined;

const RenderText = ({
  text,
  isAmount = false,
  plainAmount = false,
  color = "var(--mantine-color-dark-6)",
  fontWeight = 500,
  size = "sm",
  style = {},
  component,
  fallback = "-",
  ...rest
}: RenderTextProps) => {
  let content: ReactNode;

  if (isAmount) {
    if (typeof text === "number") {
      content = Number.isFinite(text) ? (plainAmount ? currencyFormat(text) : tugrug(text)) : fallback;
    } else if (typeof text === "string" && text !== "") {
      content = text;
    } else {
      content = fallback;
    }
  } else if (isNullish(text) || text === "") {
    content = fallback;
  } else {
    content = text;
  }

  return (
    <Text
      {...rest}
      size={size}
      fw={fontWeight}
      c={color}
      ta={isAmount ? "end" : undefined}
      w={isAmount ? undefined : "max-content"}
      maw={isAmount ? undefined : "100%"}
      style={{ whiteSpace: isAmount ? "nowrap" : undefined, wordBreak: isAmount ? undefined : "break-word", ...style }}
      component={component ? component : undefined}>
      {content}
    </Text>
  );
};

export default RenderText;
